export default "__VITE_ASSET__Dx1O9ykp__"